import {GlossaryTerm} from "../types/GlossaryTerm";

export const PRICES_ADDRESS_GLOSSARY_TERMS: GlossaryTerm[] = [
    {
        title: "Cena transakcyjna",
        description: "Kwota faktycznie zapłacona, wpisana do aktu notarialnego. Wszystkie liczby na tej stronie są tego typu — nie są to ceny z ogłoszeń."
    },
    {
        title: "Mediana",
        description:
            "Cena środkowa: połowa mieszkań była tańsza, połowa droższa. Odporna na jedną skrajną transakcję, dlatego lepiej opisuje typowe mieszkanie niż średnia."
    },
    {
        title: "RCN",
        description: "Rejestr Cen Nieruchomości — baza prowadzona przez starostwa na podstawie aktów notarialnych. Stąd bierzemy ceny transakcyjne."
    },
    {
        title: "Rynek pierwotny",
        description: "Mieszkania kupowane bezpośrednio od dewelopera, najczęściej nowe i nigdy niezamieszkane."
    },
    {
        title: "Rynek wtórny",
        description:
            "Mieszkania kupowane od poprzedniego właściciela, a nie od dewelopera. Statystyki na tej stronie łączą transakcje z rynku pierwotnego i wtórnego."
    },
    {
        title: "zł/m²",
        description: "Cena za metr kwadratowy: cena mieszkania podzielona przez jego powierzchnię. Pozwala porównywać mieszkania o różnym metrażu."
    },
    {
        title: "Opóźnienie danych",
        description:
            "Akt notarialny trafia do rejestru z opóźnieniem — na rynku pierwotnym nawet do 2 lat, bo wpis następuje przy przeniesieniu własności. Najnowsze miesiące mogą się jeszcze uzupełnić o kolejne transakcje."
    }
];
import {GlossaryTerm} from "../types/GlossaryTerm";

export const PRICES_ADDRESS_GLOSSARY_TERMS: GlossaryTerm[] = [
    {
        title: "Cena transakcyjna",
        description: "Kwota faktycznie zapłacona, wpisana do aktu notarialnego. Wszystkie liczby na tej stronie są tego typu — nie są to ceny z ogłoszeń."
    },
    {
        title: "Mediana",
        description:
            "Cena środkowa: połowa mieszkań była tańsza, połowa droższa. Odporna na jedną skrajną transakcję, dlatego lepiej opisuje typowe mieszkanie niż średnia."
    },
    {
        title: "RCN",
        description: "Rejestr Cen Nieruchomości — baza prowadzona przez starostwa na podstawie aktów notarialnych. Stąd bierzemy ceny transakcyjne."
    },
    {
        title: "Rynek pierwotny",
        description: "Mieszkania kupowane bezpośrednio od dewelopera, najczęściej nowe i nigdy niezamieszkane."
    },
    {
        title: "Rynek wtórny",
        description:
            "Mieszkania kupowane od poprzedniego właściciela, a nie od dewelopera. Statystyki na tej stronie łączą transakcje z rynku pierwotnego i wtórnego."
    },
    {
        title: "zł/m²",
        description: "Cena za metr kwadratowy: cena mieszkania podzielona przez jego powierzchnię. Pozwala porównywać mieszkania o różnym metrażu."
    },
    {
        title: "Opóźnienie danych",
        description:
            "Akt notarialny trafia do rejestru z opóźnieniem — na rynku pierwotnym nawet do 2 lat, bo wpis następuje przy przeniesieniu własności. Najnowsze miesiące mogą się jeszcze uzupełnić o kolejne transakcje."
    }
];
